import { GetApp } from "../../App"
import { GetShip } from "../../App/Context"
import { Block } from "../../Components/Block"
import { IShipVesselType } from "../../Types"
import { GetShipView } from "../ShipView"
import { PrintHeaderViewProps } from "./Params"

export function PrintHeaderView(_: PrintHeaderViewProps) {
  const app = GetApp();
  const ship = GetShip();
  const shipView = GetShipView();
  const t = app.getT("PrintHeaderView");

  const vesselType = ship.vesselType === IShipVesselType.sailing ? t("sailing") : t("motor");

  return (
    <Block className="PrintHeaderView">
      <h1>{t("title", { view: t(`print_${shipView.printMode}`), ship: `${vesselType} ${ship.name}` })}</h1>
    </Block>
  );
}
